import { useDispatch } from "react-redux";
import { LoginUser } from "../../actions/User";

const Loginfield = () =>
{

  const dispatch = useDispatch();
  const HandleSubmit = (evt) =>
  {

    console.log(evt.target[0].value)
    dispatch(LoginUser(evt.target[0].value))
    evt.preventDefault();

  }
  return (
    <div>
      This is super fucking scuffed atm just choose a name
      <form onSubmit={(evt) => HandleSubmit(evt)}>
        <input autoFocus type="text" placeholder="sus"></input>
      </form>

    </div>
  )
}

export default Loginfield;